export default __webpack_public_path__ + "assets/instagram-footer-preview.48f25c77.png";